import React from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "../../component/Navbar/Navbar";

const WindowsIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="currentColor"
    aria-hidden="true"
  >
    <path d="M3 5.5 11 4v8H3V5.5zM12 3.85 21 2.5V12h-9V3.85zM3 13h8v7.15L3 19V13zm9 0h9v8.5L12 20.15V13z" />
  </svg>
);

const SignupSuccess = () => {
  const navigate = useNavigate();

  return (
    <div className="bg-white md:p-4 p-3 max-w-screen-2xl mx-auto min-h-screen flex flex-col">
      <Navbar />

      <div className="relative mt-6 md:mt-0 rounded-2xl overflow-hidden border border-[#3AB1F626] flex-1 flex flex-col">
        <div className="absolute inset-0 bg-[#D8EFFD] opacity-50 pointer-events-none" />

        <div
          className="absolute pointer-events-none rounded-full"
          style={{
            width: "min(650px, 75vw)",
            height: "min(650px, 75vw)",
            left: "-15%",
            bottom: "-25%",
            background: "#3AB1F6",
            opacity: 0.65,
            filter: "blur(140px)",
            WebkitFilter: "blur(140px)",
          }}
        />
        <div
          className="absolute pointer-events-none rounded-full"
          style={{
            width: "min(650px, 75vw)",
            height: "min(650px, 75vw)",
            right: "-15%",
            bottom: "-25%",
            background: "#3AB1F6",
            opacity: 0.65,
            filter: "blur(140px)",
            WebkitFilter: "blur(140px)",
          }}
        />

        <div className="relative z-10 flex-1 flex flex-col items-center justify-center px-4 sm:px-6 md:px-8 py-12 sm:py-16 md:py-20">
          <h1 className="font-inter font-semibold text-black text-center text-[22px] sm:text-[28px] md:text-[34px] lg:text-[38px] leading-tight tracking-[-0.03em] mb-3 px-2">
            Click Below To Finish Login
          </h1>
          <p className="font-inter font-normal text-[#00000080] text-center text-[14px] sm:text-[16px] md:text-[18px] lg:text-[19.44px] leading-[150%] tracking-[-0.03em] max-w-[584px] mb-6 sm:mb-8 px-2">
            Press the below button to successfully log back into Zero Typing AI.
          </p>

          <button
            type="button"
            onClick={() => navigate("/app")}
            style={{
              background: "linear-gradient(90deg, #3AB1F6 0%, #407BFF 100%)",
              border: "1px solid #9797970A",
            }}
            className="hover:opacity-90 transition-opacity duration-300 ease-in-out text-white rounded-full flex items-center w-[200px] sm:w-[232px] h-[52px] sm:h-[60px] pl-[7px] sm:pl-[9px] pr-[28px] sm:pr-[41px] py-[7px] sm:py-[9px] gap-[16px] sm:gap-[22px] shadow-md"
          >
            <span className="bg-white text-[#3AB1F6] rounded-full w-[38px] h-[38px] sm:w-[42px] sm:h-[42px] flex items-center justify-center shrink-0">
              <WindowsIcon />
            </span>
            <span className="font-inter font-semibold text-[14px] sm:text-[16px] whitespace-nowrap">
              Return to App
            </span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default SignupSuccess;
